// Home.js
import React from 'react';
import "./pages.css"
const Awards = () => {
  return (
      <div className="center-container">
        <ul className='ul-list'>
          <li className='award-item'>University Merit Scholarship, BUET</li>
          <li className='award-item'>Dean’s List Award, BUET</li>  
          <li className='award-item'>Higher Secondary Scholarship, Dhaka Education Board, Bangladesh</li>
          <li className='award-item'>Best Paper Award for Sparse Mat: A Tale of Devising A Low-Cost Directional System</li>
          <li className='award-item'>Icon of the Month Award from Samsung Research, Bangladesh </li>
        </ul>
      </div>
    );
};

export default Awards;